import { useTranslation } from "react-i18next";
import ArrowButton from "./ArrowButton";
import "./GlobalLeaderScreen.scss";
import image from "./images/global-leader-image.jpg";

function GlobalLeaderScreen() {
  const { t, i18n } = useTranslation();
  return (
    <div className="global-leader-screen-container">
      <div className="mobile-hero">
        <img src={image} alt="woman looking at her phone" />
      </div>
      <div className="global-leader-screen-white-gradient">
        <div className="image-container"></div>
        <div className="container ">
          <div className="text-container-right">
            <h1 className="blue-header">
              <div
                dangerouslySetInnerHTML={{
                  __html: t("Innovate.global-leader-title", {
                    interpolation: { escapeValue: false },
                  }),
                }}
              />
            </h1>
            <p>{t("Innovate.global-leader-paragraph")}</p>
            <div className={"global-leader-card-container"}>
              <div className={"global-leader-card"}>
                <p className={"number"}>{t("Innovate.global-leader-6M")}</p>
                <p
                  className={"description"}
                  dangerouslySetInnerHTML={{
                    __html: t("Innovate.global-leader-contact-center-seats", {
                      interpolation: { escapeValue: false },
                    }),
                  }}
                ></p>
              </div>
              <div className={"global-leader-card"}>
                <p className={"number"}>{t("Innovate.global-leader-top10")}</p>
                <p className={"description"}>
                  {t("Innovate.global-leader-airlines")}
                </p>
              </div>
              <div className={"global-leader-card"}>
                <p className={"number"}>{t("Innovate.global-leader-top10")}</p>
                <p
                  className={"description"}
                  dangerouslySetInnerHTML={{
                    __html: t(
                      "Innovate.global-leader-global-automotive-companies",
                      {
                        interpolation: { escapeValue: false },
                      }
                    ),
                  }}
                ></p>
              </div>
              <div className={"global-leader-card"}>
                <p className={"number"}>{t("Innovate.global-leader-8k")}</p>
                <p
                  className={"description"}
                  dangerouslySetInnerHTML={{
                    __html: t("Innovate.global-leader-global-channel", {
                      interpolation: { escapeValue: false },
                    }),
                  }}
                ></p>
              </div>
              <div className={"global-leader-card"}>
                <p className={"number"}>{t("Innovate.global-leader-8k")}</p>
                <p
                  className={"description"}
                  dangerouslySetInnerHTML={{
                    __html: t(
                      "Innovate.global-leader-healthcare-organizations",
                      {
                        interpolation: { escapeValue: false },
                      }
                    ),
                  }}
                ></p>
              </div>
              <div className={"global-leader-card"}>
                <p className={"number"}>{t("Innovate.global-leader-4k")}</p>
                <p
                  className={"description"}
                  dangerouslySetInnerHTML={{
                    __html: t(
                      "Innovate.global-leader-patents-and-applications",
                      {
                        interpolation: { escapeValue: false },
                      }
                    ),
                  }}
                ></p>
              </div>
            </div>
            <div className={"arrow-buttons-container-right"}>
              <ArrowButton to="/" side="left"></ArrowButton>
              <ArrowButton
                to="/innovation-evolution"
                side="right"
              ></ArrowButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GlobalLeaderScreen;
